export default "__VITE_ASSET__CwliBuY$__"